<template>
  <div class="device-monitor_map">
    <BMap ref="bmap" @loaded="bmapLoaded" @mapHandler="mapHandler" />
  </div>
</template>

<script>
import BMapComp from '@/components/bmap';
// import BMap from '@/components/bmapGL';
import { colors, infoContent, patchDeviceMarker, initMarker, setLabel, to } from '@/utils/bmapUtil';
import { mapState } from 'vuex';
import { isDevice } from '@/utils/deviceUtils';
// import { toBmapPos2 } from '@/utils/bmapUtil';

export default {
  name: 'monitorMap',
  components: { BMap: BMapComp },
  inject: ['addToMonitorList'],
  data() {
    return {
      labelMap: {},
      markerMap: {},
      bmap: null,
      deviceList: [],
      infoWindow: null
    };
  },
  computed: {
    ...mapState('socket', ['deviceIdMap', 'devicesSourseMap']),
    ...mapState('device', ['monitorMenuActive', 'monitorConfig']),
    filterNoPosDevices() {
      return this.devicesSourseMap.filter(e => e.latitude !== 0 || e.longitude !== 0);
    }
  },
  //   mounted() {
  //     window.addEventListener('beforeunload', this.handleBeforeUnload);
  //   },
  //   beforeDestroy() {
  //     window.removeEventListener('beforeunload', this.handleBeforeUnload);
  //   },
  methods: {
    // handleBeforeUnload() {
    // //   sessionStorage.removeItem('correctionFlag');
    // },
    mapHandler(theme) {
      if (theme) {
        this.bmap.setMapStyleV2({ styleJson: theme });
      }
    },
    bmapLoaded(bmap) {
      this.bmap = bmap;
      this.$nextTick(() => {
        const point = new (window.BMapGL || window.BMap).Point(106.387456, 34.925406);

        const zoomCtrl = new (window.BMapGL || window.BMap).NavigationControl();

        bmap.addControl(zoomCtrl, (window.BMapGL || window.BMap).BMAP_ANCHOR_TOP_LEFT);

        this.bmap.centerAndZoom(point, 5);
        // this.isCoordinateProcessed = sessionStorage.getItem('correctionFlag') || false;

        // if (!this.isCoordinateProcessed) {
        //   Object.values(this.deviceIdMap).forEach(e => {
        //     if (e.nodeType === 1) return;
        //     if (e.longitude === 0 || e.latitude === 0) return;
        //     let positionArr = toBmapPos2({ coordinate: [e.longitude, e.latitude] });
        //     e.longitude = positionArr[0];
        //     e.latitude = positionArr[1];
        //   });

        //   this.isCoordinateProcessed = true;
        //   sessionStorage.setItem('correctionFlag', true);
        // }

        initMarker({
          deviceIdMap: this.deviceIdMap,
          source: this.filterNoPosDevices,
          markerMap: this.markerMap,
          bmap: this.bmap,
          clickCallback: e => this.showInfoWindow(e)
        });
        this.monitorMenuActiveChange(this.monitorMenuActive);
      });
    },
    openInMultiMonitor(params) {
      this.addToMonitorList(params);
    },
    showInfoWindow({ name, state = -1, sn, longitude, latitude, parentId, deviceType }) {
      if (this.infoWindow) {
        this.infoWindow.setContent(
          infoContent({
            name,
            state,
            sn,
            deviceType,
            colors,
            parentId,
            deviceIdMap: this.deviceIdMap,
            router: this.$router,
            multiMonitorCallback: () => this.openInMultiMonitor({ sn, deviceType })
          })
        );

        if (this.infoWindow.setTitle) {
          this.infoWindow.setTitle(deviceType);
        } else if (this.infoWindow.setConfig) {
          this.infoWindow.setConfig?.({ title: deviceType });
        }
      } else {
        this.infoWindow = new BMapGL.InfoWindow(
          infoContent({
            name,
            state,
            colors,
            sn,
            deviceType,
            parentId,
            deviceIdMap: this.deviceIdMap,
            router: this.$router,
            multiMonitorCallback: () => this.openInMultiMonitor({ sn, deviceType })
          }),
          { offset: new BMapGL.Size(0, -20), title: deviceType }
        );
      }
      this.bmap.openInfoWindow(this.infoWindow, new BMapGL.Point(longitude, latitude));
    },
    locateTo({ latitude, longitude, sn, name }) {
      if (!latitude || !longitude) {
        return this.$message.warning(`${name}暂无坐标信息`);
      }

      const coordinate = [longitude, latitude];
      const content = name;
      const labelMap = this.labelMap;

      Object.keys(labelMap).forEach(e => {
        if (e !== sn) {
          this.bmap.removeOverlay(labelMap[e]);
          labelMap[e] = null;
        }
      });

      setLabel({ sn, coordinate, labelMap, content, bmap: this.bmap });
      to(this.bmap, { center: coordinate, zoom: 18 });
    },
    updateMarker(v) {
      v.forEach(e => {
        const { sn, state, longitude, latitude } = e || {};
        if (sn) {
          if (!this.markerMap[sn]) {
            initMarker({
              deviceIdMap: this.deviceIdMap,
              source: [e],
              markerMap: this.markerMap,
              bmap: this.bmap,
              clickCallback: e => this.showInfoWindow(e)
            });
          } else {
            patchDeviceMarker({
              marker: this.markerMap[sn],
              state: state,
              coordinate: [longitude, latitude]
            });
          }
        }
      });
    },
    monitorMenuActiveChange(n) {
      if (!isDevice(n.nodeType)) return;
      const device = this.deviceIdMap[n.id];

      this.locateTo(device);
    },
    mapTypeChange(n) {
      this.bmap.setMapType(n);
    }
  },
  watch: {
    filterNoPosDevices: {
      handler: 'updateMarker',
      deep: true
    },
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      deep: true
    },
    'monitorConfig.mapType': {
      handler: 'mapTypeChange',
      deep: true
    }
  }
};
</script>

<style lang="scss">
.device-monitor_map {
  height: 100%;

  .BMap_stdMpPan {
    margin-top: 30px;
    margin-left: 30px;
    transform: scale(2.5);
  }

  .BMap_stdMpZoom {
    transform: scale(1.8);
    margin-left: 30px;
    margin-top: 120px;
  }
}
</style>
